/* Page-transition skeleton — activates during slow navigations the
   shopper would otherwise see no feedback for.

   Triggers:
     - Submit on any form with `data-auth-form` (login / register / reset).
     - Click on any link with `data-page-transition`.

   The overlay is dropped automatically when the browser navigates
   to the next page. Native form behaviour is preserved — we don't
   `preventDefault`. We just paint a skeleton over the current page.
*/
(function () {
  var overlay = null;
  var armed = false;

  function getOverlay() {
    if (overlay) return overlay;
    overlay = document.querySelector('[data-page-transition-overlay]');
    return overlay;
  }

  function activate(captionKey) {
    var el = getOverlay();
    if (!el || armed) return;
    armed = true;
    if (captionKey) {
      var cap = el.querySelector('[data-page-transition-caption]');
      if (cap && captionKey) cap.textContent = captionKey;
    }
    el.classList.add('is-active');
    document.documentElement.style.setProperty('overflow', 'hidden');
  }

  // Submit handler for auth forms
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !(form instanceof HTMLFormElement)) return;
    if (!form.hasAttribute('data-auth-form')) return;
    if (!form.checkValidity()) return; // native validation will block; don't overlay

    // Disable the submit button + show inline busy state.
    var submit = form.querySelector('[data-auth-submit], button[type="submit"]');
    if (submit) {
      submit.setAttribute('aria-busy', 'true');
      submit.disabled = true;
      // Wrap original label in a span so CSS can fade it for the spinner.
      if (!submit.querySelector('.button__label')) {
        var label = submit.textContent.trim();
        submit.innerHTML = '<span class="button__label">' + label + '</span>';
      }
    }

    // Tiny delay before the overlay so the user sees the button state
    // change first — gives the impression of progressive feedback.
    var caption = form.getAttribute('data-auth-caption') || '';
    setTimeout(function () { activate(caption); }, 250);
  }, true);

  // Click handler for any link explicitly tagged for transition.
  document.addEventListener('click', function (evt) {
    var a = evt.target.closest && evt.target.closest('[data-page-transition]');
    if (!a) return;
    // Skip new-tab / modifier / external
    if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.button !== 0) return;
    if (a.target === '_blank') return;
    var caption = a.getAttribute('data-page-transition-caption') || '';
    activate(caption);
  }, true);

  // If the user navigates back via bfcache, drop the overlay.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      var el = getOverlay();
      if (el) el.classList.remove('is-active');
      armed = false;
      document.documentElement.style.removeProperty('overflow');
    }
  });
})();
